

<script setup>
  import { ref,onMounted,onUnmounted } from 'vue';// @ is an alias to /src
  // import { ElDialog } from 'element-plus'
  import index from '@/components/index.vue'
  import aboutUs from '@/components/aboutUs.vue'
  import feature from '@/components/feature.vue'
  import contactUs from '@/components/contactUs.vue'
  const titIndex = ref(0)
  const titList = ref([
    {
      name:'首页',
      id:'index'
    },{
      name:'关于我们',
      id:'aboutUs'
    },{
      name:'功能介绍',
      id:'feature'
    },{
      name:'联系我们',
      id:'contactUs'
    },
  ])
  onMounted(() => {
    // 挂载时添加滚动事件监听器
    window.addEventListener('scroll', handleScroll);
  });

  onUnmounted(() => {
    // 卸载时移除滚动事件监听器
    window.removeEventListener('scroll', handleScroll);
  });

  // 处理滚动事件的方法
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    for(let i = 0; i<titList.value.length; i++){
      const targetElement = document.getElementById(titList.value[i].id);
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
          console.log(targetElement.id,'targetElement===')
          if(targetElement.id==='index')
            titIndex.value = 0
          else if(targetElement.id==='aboutUs')
            titIndex.value = 1
          else if(targetElement.id==='feature')
            titIndex.value = 2
          else if(targetElement.id==='contactUs')
            titIndex.value = 3
        }
      }
    }
  };
  const scrollToSection = (index) => {
    console.log(titIndex.value,'titIndex.value')
    console.log(index,'index')
    titIndex.value = index
    var sectionId = ''
    if(index===0)
      sectionId = 'index'
    else if(index===1)
      sectionId = 'aboutUs'
    else if(index===2)
      sectionId = 'feature'
    else if(index===3)
      sectionId = 'contactUs'
    console.log(sectionId,'sectionId')
  const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        block: 'start' // 滚动到元素顶部对齐
      });
    }
  };
</script>
<template>
  <div class="home">
    <div class="titles">
        <img class="indexLogo" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/indexLogo.png" alt="">
        <div class="titRight">
          <p @click="scrollToSection(index)" :class="index==titIndex?'Selectrir rirList':'rirList'" v-for="(item,index) in titList" :key="index">{{item.name}}</p>
        </div>
    </div>
    <index id="index"/>
    <aboutUs id="aboutUs"/>
    <feature id="feature"/>
    <contactUs id="contactUs"/>
    <div class="bottomse">
      Copyright © 2021 佰业绿色科技（青岛）有限公司 | <a class="a_link" href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2021023110号-1</a >
    </div>

  </div>
</template>
<style lang="less" scoped>
.a_link{
  color: #fff;
  text-decoration: none;
}
.home{
  // padding-bottom: 200px;
  /* background: red; */
  min-width: 1200px;
  max-width: 1477px;
  background: #fff;
  margin: 0 auto;
  #aboutUs{
    margin-top: -5px;
  }
  .codeCenter{
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(#000,0);
    .codeImg{
      width: 50%;
    }
    .dialogClose{
      width: 40px;
      margin-top: 40px;
    }
  }
  /deep/ .el-dialog{
    background: rgba(0,0,0,0) !important;
  }
  .bottomse{
    width: 100%;
    height: 50px;
    background: #014446;
    font-size: 12px;
    color: #fff;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 180px;

  }
}
.titles{
  width: 100%;
  height: 75px;
  position: fixed;
  display: flex;
  align-items: center;
  background-color: rgba(0,0,0,0.2);
  backdrop-filter: blur(10px);
  /* filter: blur(2px); */
  border-bottom: 1px solid rgba(255,255,255,0.5);
  display: flex;
  align-items: center;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 1477px;
  z-index: 15;
}
.indexLogo{
  width:142px ;
  margin-left: 130px;
  margin-right: 380px;
}
.titRight{
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
}
.rirList{
  height: 92%;
  width: 65px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 6px solid rgba(255,255,255,0);
  cursor: pointer;
  color: #dfdfdf;
  transition: border 1s;
}
.Selectrir{
  border-bottom: 6px solid #fff;
  color: #fff;
  font-weight: 500;
  transition: border 1s;
}
</style>